import { StepFrame } from "@/features/onboarding/components/StepFrame";
import { useCardEditor } from "@/features/cards/hooks/useCardEditor";
import { CardEditor, CardLoadState, isCardEditorReady } from "@/features/cards/components/CardEditor";
import { useProfileTheme } from "@/features/profiles/hooks/useProfileTheme";
import { ProfileThemeEditor, ThemeLoadState } from "@/features/profiles/components/ProfileThemeEditor";

export function NeedsCard({ testId }) {
  return (
    <div data-testid={testId} className="rounded-lg border border-dashed border-border p-6 text-sm">
      Your card isn't saved yet. Go back to the card step and save it — its link becomes your profile link.
    </div>
  );
}

export function CardStep({ step, onBack, onNext }) {
  const editor = useCardEditor();
  const ready = isCardEditorReady(editor);
  const next = async () => {
    if (editor.card && !editor.dirty) return onNext();
    if (await editor.save()) onNext();
  };
  return (
    <StepFrame step={step} onBack={onBack} onNext={next} busy={editor.status.state === "saving"} nextDisabled={!ready} status={editor.status}>
      {ready ? <CardEditor editor={editor} /> : <CardLoadState editor={editor} />}
    </StepFrame>
  );
}

export function ProfileStep({ step, onBack, onNext }) {
  const t = useProfileTheme();
  const ready = t.load.status === "ready";
  const hasCard = ready && Boolean(t.load.card);
  const next = async () => {
    if (!hasCard) return onBack();
    if (t.load.pp && !t.dirty) return onNext();
    if (await t.save()) onNext();
  };
  return (
    <StepFrame step={step} onBack={onBack} onNext={next} nextLabel={ready && !hasCard ? "Back to card" : "Save & continue"} busy={t.status.state === "saving"} nextDisabled={!ready} status={t.status}>
      {!ready ? <ThemeLoadState t={t} /> : hasCard ? <ProfileThemeEditor t={t} /> : <NeedsCard testId="onboarding-profile-needs-card" />}
    </StepFrame>
  );
}
